import { cva } from 'class-variance-authority'

export const buttonVariants = cva('button', {
  variants: {
    variant: {
      default: 'default',
      ghost: 'ghost',
      secondary: 'secondary',
      destructive: 'destructive',
    },
    size: {
      'default': 'default',
      'sm': 'sm',
      'icon': 'icon',
      'icon-sm': 'icon-sm',
      'xs': 'xs',
    },
  },
  defaultVariants: {
    variant: 'default',
    size: 'default',
  },
})
